import React, { useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import AsyncButton from 'src/components/general/AsyncButton';
import ScfoButton from 'src/components/shared/ScfoButton';
import { useDispatch } from 'react-redux';
import { importAlertState } from 'src/redux/actions/alert';
import { importUpdateCashflowNeeded } from 'src/redux/actions/flujocaja';
import { updateConcilieantionRatio } from 'src/redux/actions/dashboard';
import { setUpdateDocuments } from 'src/redux/actions/documentostributarios';
import { GenerateMultipleUnMatch } from 'src/graphql/conciliacion';
import CustomModal from '../../configuracion/components/customModal';

export const RevertPayoff = ({ companyId, option, selected }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const { executeMutation: unGenerateMultipleMatch } = GenerateMultipleUnMatch()

    const handleSubmit = async () => {
        try {
      
          const inputs = selected.flatMap((document) =>
            document.meta.matchs.inMatch.map((match) => ({
              companyId,
              originId: document.id || document._id,
              originType: document.documentType,
              endType: match.type,
              endId: match.id || match._id || match.settleId,
            }))
          );
      
          if (inputs.length > 0) {
            const { error } = await unGenerateMultipleMatch({ input: inputs });
      
            if (error) {
              throw new Error("Error al revertir documentos");
            }
          }
      
          handleClose();
          dispatch(importUpdateCashflowNeeded({ value: true, reload: null }));
          dispatch(updateConcilieantionRatio());
          dispatch(setUpdateDocuments({ value: true }));
      
          dispatch(
            importAlertState({
              content:
                selected.length > 1
                  ? "Documentos revertidos con éxito"
                  : "Documento revertido con éxito",
              state: "success",
              duration: 3,
            })
          );
        } catch (error) {
          console.error("Error al ejecutar la reversión:", error);
          const errorMessage = error?.graphQLErrors?.[0]?.message || error?.message || "Hubo un problema al revertir los documentos.";
          const isPeriodLocked = errorMessage && typeof errorMessage === 'string' && 
            errorMessage.toLowerCase().includes('período') && 
            errorMessage.toLowerCase().includes('cerrado');
          dispatch(
            importAlertState({
              concept: isPeriodLocked ? "Período Cerrado" : undefined,
              content: errorMessage,
              state: isPeriodLocked ? "warning" : "error",
              duration: isPeriodLocked ? 6 : 4,
            })
          );
        }
      };
      
      
    return (
        <>
            <Dropdown.Item value={option?.value} onClick={handleOpen}>
                {option?.text}
            </Dropdown.Item>
            <CustomModal
                open={open}
                onClose={handleClose}
                dimmer="blurring"
                size="tiny"
                title="Revertir"
                content={
                    <>
                <p>¿Estás seguro que deseas revertir los pagos de este documento?</p>
                <p>Esta acción no se puede deshacer</p>
                    </>
                }
                customActions={
                    <div className="tw-flex tw-justify-end tw-gap-2 tw-w-full tw-flex-wrap">
                        <ScfoButton type="button" variant="ghost" onClick={handleClose}>
                            Cancelar
                        </ScfoButton>
                        <AsyncButton onClick={handleSubmit} primary>
                            Sí, revertir
                        </AsyncButton>
                    </div>
                }
            />
        </>
    );
};
